import { LoadingButton } from "@mui/lab";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
    InputFile,
    InputText,
    InputTextArea,
    setTitleCase,
} from "app/components/template/partials";
import { Field, Formik } from "formik";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

// REDUX
import { editDocumentation } from "utils/action";
import { toServerURL } from "utils/generator";

// inital values form
const initialValues = (initForm) => {
    return {
        title: initForm?.title ?? "",
        content: initForm?.content ?? "",
        photo_url: initForm?.photo_url ?? "",
        is_show_documentation: initForm?.is_show_documentation ?? "false",
    };
};

// form field validation schema
const validationSchema = Yup.object().shape({
    title: Yup.string().required("Judul wajib diisi!"),
});

export function EditDocumentation() {
    const [isLoading, setLoading] = useState(false);
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const showDialog = location.state?.showDialog ?? false;
    const documentationData = location.state?.documentationData ?? null;
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    const [selectedphoto, setSelectedPhoto] = useState(null);

    const handleUploadPhoto = (event) => {
        const file = event.target.files[0];
        setSelectedPhoto(file);
    };

    const onHide = () => {
        navigate(-1);
    };

    const handleFormSubmit = async (values) => {
        setLoading(true);

        const formData = new FormData();
        formData.append("photo", selectedphoto);
        formData.append("title", values.title);
        formData.append("content", values.content);
        formData.append("is_show_documentation", values.is_show_documentation);

        try {
            await editDocumentation(documentationData.id, formData);
            toast.success(setTitleCase("berhasil menambahkan dokumentasi"));
        } catch (error) {
            toast.error(setTitleCase(error.response.data?.message));
        }
        setLoading(false);
        onHide();
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            open={showDialog}
            onClose={onHide}
            aria-labelledby="responsive-dialog-create-documentation-title"
        >
            <DialogTitle id="responsive-dialog-create-documentation-title">
                Edit Pelanggan
            </DialogTitle>
            <Divider />
            <Formik
                enableReinitialize
                onSubmit={handleFormSubmit}
                initialValues={initialValues(documentationData)}
                validationSchema={validationSchema}
            >
                {({ handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <DialogContent className="dialog-container">
                            <Grid container spacing={3}>
                                <Grid item md={12} xs={12}>
                                    <Field
                                        component={InputText}
                                        name="title"
                                        label="Judul Dokumentasi"
                                        size="small"
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item md={12} xs={12}>
                                    <Field
                                        component={InputTextArea}
                                        minRows={3}
                                        maxRows={10}
                                        value={values.content}
                                        name="content"
                                        label="Konten Dokumentasi"
                                        variant="outlined"
                                        type="text"
                                        className="custom-textarea"
                                    />
                                </Grid>
                                <Grid item md={12} xs={12}>
                                    <img
                                        src={toServerURL(
                                            initialValues(documentationData)
                                                .photo_url
                                        )}
                                        alt={
                                            initialValues(documentationData)
                                                .title
                                        }
                                        style={{
                                            maxWidth: "250px",
                                            maxHeight: "250px",
                                            filter: selectedphoto
                                                ? "blur(8px)"
                                                : "none",
                                        }}
                                    />
                                </Grid>
                                <Grid item md={12} xs={12}>
                                    <Field
                                        component={InputFile}
                                        name="photo"
                                        labelButton="Upload Gambar baru"
                                        selectedphoto={selectedphoto}
                                        onChange={handleUploadPhoto}
                                    />
                                </Grid>
                                {selectedphoto && (
                                    <Grid item md={12} xs={12}>
                                        <div>
                                            Foto yang dipilih:{" "}
                                            {selectedphoto.name}
                                        </div>
                                        <img
                                            src={URL.createObjectURL(
                                                selectedphoto
                                            )}
                                            alt={selectedphoto.name}
                                            style={{
                                                maxWidth: "250px",
                                                maxHeight: "250px",
                                            }}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </DialogContent>
                        <Divider />
                        <DialogActions>
                            <LoadingButton
                                autoFocus
                                loading={isLoading}
                                type="submit"
                                color="primary"
                                variant="contained"
                            >
                                Simpan
                            </LoadingButton>
                            <Button
                                autoFocus
                                onClick={onHide}
                                color="error"
                                variant="contained"
                                sx={{ marginLeft: "1rem" }}
                            >
                                Batal
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Formik>
        </Dialog>
    );
}
